import { Icon } from '@iconify/react'

const Header = () => {
  return (
    <header className="flex justify-between items-center px-4 py-4">
      <h1 className="text-xl font-bold text-black">계약 호구방지</h1>
      <button className="text-black">
        <Icon icon="solar:hamburger-menu-bold" width={24} height={24} />
      </button>
    </header>
  )
}

export default Header

